import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { ServiceRequestClaimInitStepDeclaration } from "./Steps/ServiceRequestClaimInitStep";
import { ServiceRequestClaimTransition } from "./Transition/ServiceRequestClaimTransition";

export const ServiceRequestClaimStartupFlow = new FlowDefinition("ServiceRequestClaimFlow");

ServiceRequestClaimStartupFlow.addStep(ServiceRequestClaimInitStepDeclaration);

ServiceRequestClaimStartupFlow.addLink("ServiceRequestClaimInit_Step", "ServiceRequestClaimInit_Step");

ServiceRequestClaimStartupFlow.addTransition(ServiceRequestClaimTransition, "ServiceRequestClaimInit_Step")

ServiceRequestClaimStartupFlow.setStartStep("ServiceRequestClaimInit_Step");

export const RetrieveBookingStartupStepDefinition = new StepDefinition({
    stepName: "ServiceRequestClaimFlow",
    stepFlow: ServiceRequestClaimStartupFlow,
    contextIsolation: false
})
